import gql from 'graphql-tag';

const DISTRICTS = gql`
query districts( $offset: Int, $limit: Int, $sort: [DistrictSortInput!], $filter: [DistrictFilterInput]){
  districts(offset: $offset, limit: $limit, sort:$sort, filter: $filter ) {
    items {
      id
      code
      name
      order
    }
  }
}
`;

export default DISTRICTS;